import React from 'react'
import { Chip, ChipProps } from '@mui/material'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { ReferralStatus } from '../../../../../models/graphqlTypes'

const mapStatusToColor = (status: ReferralStatus): ChipProps['color'] => {
  switch (status) {
    case ReferralStatus.Created:
    case ReferralStatus.AppointmentBooked:
      return 'success'
    case ReferralStatus.Expired:
    case ReferralStatus.Deleted:
      return 'error'
    case ReferralStatus.Finished:
    case ReferralStatus.WaitingOnResult:
      return 'success'
  }
}

interface ReferralStatusChipProps {
  status: ReferralStatus
}

const ReferralStatusChip: React.FC<
  React.PropsWithChildren<ReferralStatusChipProps>
> = ({ status }) => {
  const { t } = useTranslation()

  return (
    <Chip
      label={t(`doctor:referral.status.${status.toLowerCase()}`)}
      color={mapStatusToColor(status)}
      size="small"
    />
  )
}

export { ReferralStatusChip }
